import { useEffect } from 'react';
import { Box, CircularProgress, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Button } from '@mui/material';
import { ErrorHeader } from '../../shared/errorHeader';
import { useParams } from 'react-router-dom';
import { formatHeight } from '../../utils/dataFormatters';
import { useForm } from 'react-hook-form';
import { AthleteProvider, useAthlete } from '../../providers/athleteProvider';
import { ManageAthleteForm } from './manageAthleteForm';

export function ManageAthletePage() {
  const params = useParams();


  return (
    <Box>
        <AthleteProvider athleteGuid={params.athleteGuid || ''}>
       <ManageAthleteForm />
        </AthleteProvider>
      </Box>
  );
}